// extracted by mini-css-extract-plugin
export default {"blocklyBuild":"_xNY7RJBTaps8rMCvTfEm"};